import BuildingIcon from '../../../icons/building.svg'
import BuildingsGroupIcon from '../../../icons/buildings-group.svg'
import DoneIcon from '../../../icons/done.svg'
import FaqIcon from '../../../icons/faq.svg'
import InvoiceIcon from '../../../icons/invoice.svg'
import ReplyIcon from '../../../icons/reply.svg'
import ServiceRequestIcon from '../../../icons/service-request.svg'
import TaskIcon from '../../../icons/task.svg'

export const PROMPT_ICON = {
  'default-at-address': BuildingIcon,
  'default-capabilities': FaqIcon,
  'default-draft-reply': ReplyIcon,
  'default-my-requests': ServiceRequestIcon,
  'default-today-first': TaskIcon,
  'default-top-building': BuildingsGroupIcon,
  'finance-approval': DoneIcon,
  'finance-due': TaskIcon,
  'finance-paid': InvoiceIcon,
}
